import { useChatStore } from "../Store";
import { useUserStore } from "@/Modules/User/Store";

import { getChats } from "@/Services/TherapyApi/Chat";

import { transformChatApiToChatRoom } from "../Transformers/Chat";

import { hasValue } from "@/Utils/Objects";

const CreateBotStageAnswerActionHandler = async (): Promise<void> => {
  const chatStore = useChatStore();
  const userStore = useUserStore();

  chatStore.isLoadingChats = true;

  const chats = await getChats();

  if (hasValue(userStore.user) && hasValue(chats)) {
    const role = userStore.user.role;
    const chatRooms = chats.map((c) => transformChatApiToChatRoom(c, role, [], userStore.user!));

    chatStore.rooms = chatRooms.reduce((acc, currentChat) => {
      return { ...acc, [currentChat.id]: currentChat };
    }, {});

    chatStore.isLoadingChats = false;
  } else {
    chatStore.isLoadingChats = false;
  }

  return;
};

export default CreateBotStageAnswerActionHandler;
